import { boot } from '@dazn/bootstrap-lib';

export const warnAboutDuplictaes = (
    customAttributes: boot.fflag.CustomAttributes,
    defaultAttributes: boot.fflag.DefaultAttributes,
): void => {
    const duplicates = Object.keys(customAttributes).filter(
        attrKey => attrKey in defaultAttributes,
    );

    if (duplicates.length > 0) {
        console.warn(
            `[Bootstrap] You are trying to override default attributes: ${duplicates.join(
                ', ',
            )}`,
        );
    }
};
